import React, { Component } from 'react';

class StandAloneAdvisoryContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            language: this.props.language
        };
        this.removeAdvisory = this.removeAdvisory.bind(this);
    }

    removeAdvisory(AdvisoryId) {
        this.state.data.map((items, index) => {
            if (items.AdvisoryId == AdvisoryId) {
                var index = this.state.data.findIndex((item) => item.AdvisoryId == AdvisoryId);
                this.state.data.splice(index, 1);
                this.setState({ data: this.state.data });
            }
        });
    }

    componentDidMount() {

        
        const orgElement = document.getElementById('organizationId');
        let organizationId = '';

        if (orgElement != 'undefined' && orgElement != null) {
            organizationId = document.getElementById('organizationId').value;
        }

        let baseUrl = '';
        if (document.getElementById('baseUrl') != 'undefined' && document.getElementById('baseUrl') != null) {
            baseUrl = document.getElementById('baseUrl').value;
        }

        const xhr = new XMLHttpRequest();
        xhr.open('GET', `${baseUrl}/api/front/getAdvisoryContent?organizationId=${organizationId}`);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onload = () => {
            if (xhr.status >= 200 && xhr.status < 300) {
                const data = JSON.parse(xhr.response);
                // console.log('data', data);
                this.setState({ data });
            } else {
                reject(`status: ${xhr.status}, statusText: ${xhr.statusText}`);
            }
        };
        xhr.onerror = () => {
            reject(`status: ${xhr.status}, statusText: ${xhr.statusText}`);
        };
        xhr.send();
    }

    render() {
         console.log('this.setstate=========>', this.state);
        return (
            <div className={(Object.keys(this.state.data).length) > 0 ? 'bs-d-flex bs-text-danger bs-font-size-sm bs-py-1 bs-justify-content-center bs-alert bs-rounded-0 bs-border-0 bs-alert-danger bs-w-100 bs-align-items-center bs-flex-wrap bs-mb-0' : 'bs-d-none'}>
                <div className="bs-container bs-position-relative">
                    {this.state.data.map((items, index) => (
                        <div className="bs-mx-2 bs-d-flex bs-w-100 bs-my-1 bs-justify-content-center" key={index}>
                            <svg xmlns="http://www.w3.org/2000/svg" id="icon-alert" viewBox="0 0 22.668 18.745" className="bs-icon bs-mr-2 bs-fill-red bs-font-weight-500">
                                <g id="noun_Alert_887235" transform="translate(0 0)">
                                    <g id="Group_4827" data-name="Group 4827" transform="translate(0 0)">
                                        <path id="Path_8697" data-name="Path 8697" d="M22.377,16.854,12.526.8A1.286,1.286,0,0,0,10.142.81L.291,16.847c-.656,1.071-.166,1.9,1.088,1.9H21.288C22.543,18.745,23.032,17.923,22.377,16.854ZM11.326,4.35c.631,0,1.119.7,1.087,1.549l-.2,5.132c-.032.851-.433,1.548-.889,1.548s-.858-.7-.89-1.548l-.2-5.132C10.2,5.047,10.694,4.35,11.326,4.35Zm0,12.095A1.284,1.284,0,0,1,10,15.067a1.334,1.334,0,1,1,2.667,0A1.3,1.3,0,0,1,11.326,16.445Z" transform="translate(0 0)" />
                                    </g>
                                </g>
                            </svg>
                            <a href={items.Link} className="bs-text-danger bs-font-weight-500">{this.state.language == 'en' ? items.Message : items.Message_FR}</a>
                            <button type="button" className="bs-close bs-position-absolute bs-position-md-relative" onClick={this.removeAdvisory.bind(null, items.AdvisoryId)} data-dismiss="alert" aria-label="Close">
                                <svg viewBox="0 22.2 778.8 777.8" id="icon-close" xmlns="http://www.w3.org/2000/svg" className="bs-icon-sm bs-fill-red">
                                    <path d="M778.8 100L701 22.2 389.9 333.3 78.8 22.2 1 100l311.1 311.1L1 722.2 78.8 800l311.1-311.1L701 800l77.8-77.8-311.1-311.1z" />
                                </svg>
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}

export default StandAloneAdvisoryContent;
